export const CANCELAR_PEDIDO = 'CANCELAR_PEDIDO';
export const ENVIAR_CONTRATO = 'ASSINATURA_CLIENTE';
export const CONFERINDO_CONTRATO = 'CONFERINDO_CONTRATO';
export const CONTRATO_CONFERIDO = 'CONTRATO_CONFERIDO';
export const CONTRATO_CANCELADO = 'CONTRATO_CANCELADO';
export const ROLLBACK = 'ROLLBACK';
